export default "<div class=\"container\">\n  <button class=\"button-alert\" (click)=\"openForm()\">{{title}}</button>\n</div>"